<template>
    <div>
        <v-row>
            <!-- class="v-label theme--light mt-3 ml-6" -->
            <v-col 
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="AzLive" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
            <v-spacer></v-spacer>
            <v-col 
                cols="3"
                align-self="end"
            >
                <BaseButton 
                    label="lang_AZ_LIVE_BUTTON_CAPTION_NEW_VENUE"
                    :to="{ name: 'AzLiveEdit', params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "AzLiveTopSlot",
    components: {
        BaseHeaderStats,
        BaseButton
    },
    data() {
        return {
            alvqa: "az-live"
        }
    }
}
</script>